var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeparturebig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.4415C25 15.3227 23.2465 18.8918 21.3333 22.8144C18.8085 27.9912 15.788 33.3563 14 34.3398C12.1659 32.9946 9.2133 28.0378 6.66667 22.8144C4.84955 19.0874 3 15.2247 3 12.4415C3 5.75796 7.92487 0.339844 14 0.339844C20.0751 0.339844 25 5.75796 25 12.4415Z",
    fill: "#254E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.4415C25 15.3227 23.2465 18.8918 21.3333 22.8144C18.8085 27.9912 15.788 33.3563 14 34.3398C12.1659 32.9946 9.2133 28.0378 6.66667 22.8144C4.84955 19.0874 3 15.2247 3 12.4415C3 5.75796 7.92487 0.339844 14 0.339844C20.0751 0.339844 25 5.75796 25 12.4415Z",
    fill: "#254E9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3398,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3398,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 11.3136C14.6443 11.3136 15.1666 10.7965 15.1666 10.1585C15.1666 9.52058 14.6443 9.00342 13.9999 9.00342C13.3556 9.00342 12.8333 9.52058 12.8333 10.1585C12.8333 10.7965 13.3556 11.3136 13.9999 11.3136Z",
    stroke: "#254E9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.2012C19.25 17.072 16.8995 19.3992 14 19.3992C11.1005 19.3992 8.75 17.072 8.75 14.2012",
    stroke: "#254E9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.8911V19.3994",
    stroke: "#254E9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.2012H8.75",
    stroke: "#254E9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.2012H17.5",
    stroke: "#254E9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparturebig);
export default __webpack_public_path__ + "static/media/departure big.2f07d84c0be037c903d44f70737bcf6f.svg";
export { ForwardRef as ReactComponent };